import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { GenericSlidersModel } from '@core/model/genericSliders.model';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { CommonService } from './common.service';
import { Injectable } from "@angular/core";
import { stringify } from 'querystring';
/*Constants */
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable()
export class GenericSliderService {

  constructor(public http: HttpClient, private router: Router, private common: CommonService) {
  }

  getLogo() {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetLogo';
    return this.http.post<GenericSlidersModel>(url, null, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getSocialNetworks(model: GenericSlidersModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetSocialNetworks';
    return this.http.post<GenericSlidersModel[]>(url, JSON.stringify(model), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getSliderImages(model: GenericSlidersModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetSliderImages';
    return this.http.post<GenericSlidersModel[]>(url, JSON.stringify(model), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }
}

